import {
  scheduleTypeDef,
  severityTypeDef,
  typeTestDef,
} from 'vdg-patients/appointment/diagnosis/test-examination/VdgTestModal'
import { patientFileReason } from './PatientFile'

export enum OrderSource {
  manual = 'manual',
  discussion = 'discussion',
  actionReport = 'actionReport',
  hospitalizationPlan = 'hospitalizationPlan',
  // Ordered from the public result viewer, off the AI's reading of that encounter.
  resultLink = 'resultLink',
  // One patient's exam in a group test order (vdg-patients/group-test-orders); placed server-side.
  groupOrder = 'groupOrder',
}

export default interface InternalExaminationPlan {
  _id?: string
  patientId: string
  scheduleType: scheduleTypeDef
  patientDiagnoses: any[]
  typeTest: typeTestDef
  test: any
  prescribedBy: any
  bloodTypes?: any
  withIn?: number | 'ASAP'
  reason?: patientFileReason
  timesADay?: number
  /** multi plans only: days between test days (1 = every day, 7 = every week). */
  everyXDays?: number
  /** multi plans only: first test day. */
  startDate?: string
  everyXHours?: number
  endPlanDate?: string
  severity?: severityTypeDef
  isClosed?: boolean
  closedBy?: string
  closedAt?: string
  closeDiscussion?: string
  /** 'edited' when the plan was closed because it was replaced by an edited copy (replacedBy). */
  closeReason?: string
  replacedBy?: string
  createdAt?: string
  additionalRequests?: string
  /**
   * Protocol context (e.g. which hospitalization day an order belongs to).
   *
   * Deliberately separate from `additionalRequests`: the med-tech app renders that field verbatim
   * and, when it is present, makes the order card expand instead of starting the exam. The
   * med-tech performs these tests as usual, so only genuine test instructions belong there.
   */
  hospitalizationNote?: string
  orderSource?: OrderSource
  /**
   * Why the test is ordered, in the prescriber's words: shown to the interpreter and written to
   * the order's progress note. Required wherever a clinician places the order (OrderReasonFields).
   */
  indication?: string
}
